import {WeeklyDish} from "../Types/WeeklyDish";
import {BasketItem} from "../Types/BasketItem";

const BASE_URL = `${process.env.REACT_APP_API_URL ?? ""}/api/Reservation`;

export type CustomerInfo = {
  name: string;
  email: string;
  phone: string;
  isDelivery: boolean;
  place?: string;
  address?: string;
  houseNumber?: string;
  postalCode?: string;
};

export type ReservationItem = {
  itemId: number;
  itemName: string;
  price: number;
  amount: number;
};

export type MakeReservationPayload = {
  customerInfo: CustomerInfo;
  items: ReservationItem[];
  date: string;
};

export function createReservationPayload(
  items: BasketItem[],
  formData: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    postcode: string;
    address: string;
  },
  isDelivery: boolean
): MakeReservationPayload {
  const { street, houseNumber } = isDelivery
    ? splitStreetAndHouseNumber(formData.address)
    : { street: "", houseNumber: "" };
  return {
    customerInfo: {
      name: `${formData.firstName} ${formData.lastName}`.trim(),
      email: formData.email,
      phone: formData.phone,
      isDelivery,
      address: isDelivery ? street : undefined,
      houseNumber: isDelivery ? houseNumber : undefined,
      postalCode: isDelivery ? formData.postcode : undefined,
      place: "Ridderkerk"
    },
    items: items.map((it) => ({
      itemId: it.id,
      itemName: it.name,
      price: it.price,
      amount: it.quantity,
    })),
    date: new Date().toISOString(),
  };
}

function splitStreetAndHouseNumber(address: string): { street: string; houseNumber: string } {
  const match = address.match(/^(\D+)\s+(\d+.*)$/);
  if (!match) {
    return { street: address.trim(), houseNumber: "" };
  }
  return {
    street: match[1].trim(),
    houseNumber: match[2].trim(),
  };
}

export async function makeReservation(item: MakeReservationPayload): Promise<WeeklyDish> {
  const res = await fetch(`${BASE_URL}/MakeReservation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  });

  if (!res.ok) throw new Error("Failed to make reservation");

  return res.json();
}